// extracted by mini-css-extract-plugin
export default {"container":"CreateOffersForm_container__xWccB","input":"CreateOffersForm_input__psqqy","text_area":"CreateOffersForm_text_area__463u2","options":"CreateOffersForm_options__kZhSs"};